/**
 * Raven library is loaded from CDN in `index.html`
 *
 * This is a convenience module to allow this to be 'imported'.
 */
const Raven = window.Raven;

export default Raven;


// WEBPACK FOOTER //
// ./src/modules/raven-cdn.js